import React from 'react';
import { ControlledComponent } from '@aha-app/mvc';
import ControlledAssistantView from '../AssistantView/ControlledAssistantView';
import AssistantViewController from '../AssistantView/AssistantViewController';
import HeaderButtons from '../HeaderPanel/HeaderButtons';
import { type SidePanelItem } from 'javascripts/shared-types';

const LazyControlledComponent = ({ getController, children }) => {
  return (
    <ControlledComponent controller={getController()}>
      {children}
    </ControlledComponent>
  );
};

const assistantSidePanelConfiguration = ({
  agentName,
  agentParams,
  agentInstances,
  alwaysRendered = false,
}): SidePanelItem | null => {
  if (!window.currentAccount?.hasGeneralAiAssistant) {
    return null;
  }

  let controller: AssistantViewController;

  function getController() {
    if (!controller) {
      // Initialize the controller directly so we can pass it to both the title and
      // the content.
      controller = new AssistantViewController();
      controller.internalInitialize(null, {
        agentName,
        agentParams,
        agentInstances,
        dock: 'side-panel',
      });
    }

    return controller;
  }

  function applyOptions(options?: Record<string, any>): void {
    const assistantController = getController();

    if (options?.startNewChat) {
      assistantController.actionNewChat();
    }

    if (options?.agentName) {
      assistantController.actionSetAgent(options.agentName);
    }

    if (options?.stickyReferences) {
      assistantController.actionSetStickyReferences(options.stickyReferences);
    }
  }

  // TODO: How does the controller get destroyed so we can clean up any network requests.

  return {
    id: 'assistant',
    name: 'AI assistant',
    icon: <aha-ai-icon />,
    alwaysRendered,
    titleContent: (
      <LazyControlledComponent getController={getController}>
        <HeaderButtons />
      </LazyControlledComponent>
    ),
    tabContent: (
      <aha-sidepanel-item>
        <aha-ai-icon />
      </aha-sidepanel-item>
    ),
    content: (
      <LazyControlledComponent getController={getController}>
        <ControlledAssistantView />
      </LazyControlledComponent>
    ),
    onOpen: applyOptions,
  };
};

export default assistantSidePanelConfiguration;
